import { useLocation } from "react-router-dom";

function LoginButtonCTA({ className = "", style = {} }) {
  const location = useLocation();

  const handleLoginClick = () => {
    // salvo la pagina corrente in localStorage
    localStorage.setItem("redirectAfterLogin", location.pathname);
    // vado al login
    window.location.replace("/login");
  };

  return (
    <button className={className} onClick={handleLoginClick} style={style}>
      Accedi
    </button>
  );
}

export default LoginButtonCTA;
